<template>
  <el-scrollbar class="content_pic">
    <div class="each_pic"
         v-for="item in contentImg"
         @click.stop='choiceOrCancleCurrentHeadImg(item)'>
      <el-image style="width: 120px; height: 120px"
                :src="item"
                :alt='alt'
                :fit="fit">
        <div slot="error"
             class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="each_insert_opacity"
           v-show="isCurrentChoice(item)">
        <div class="each_insert_choice">
          <span class="iconfont icon-check"></span>
        </div>
      </div>

    </div>

  </el-scrollbar>
</template>

<script>

export default {
  name: 'fromContent',
  components: {

  },
  data() {
    return {
      fit: 'contain',
      alt: '图片加载失败'
    }
  },
  props: {
    contentImg: {
      type: Array,
      required: true
    },
    choiceUrlList: {
      type: Array,
      required: true
    }
  },
  computed: {
    isCurrentChoice() {
      return function (item) {
        if (this.choiceUrlList.length > 0) {
          var k = 0
          for (var i = 0; i < this.choiceUrlList.length; i++) {
            if (this.choiceUrlList[i] !== item) {
              k++
            } else {
              break;
            }
          }
          if (k == this.choiceUrlList.length) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    }
  },
  methods: {
    choiceOrCancleCurrentHeadImg(item) {
      this.$emit('choiceCancleImg', item)
    }
  },



}
</script>

<style lang='stylus' scoped>
.content_pic
  all-length()
  clear both
  box-sizing border-box
  padding-top 24px
  padding-left 24px

  .each_pic
    position relative
    float left
    box-sizing border-box
    margin-bottom 24px
    margin-left 24px
    width 120px
    height 120px
    background #fff
    cursor pointer

    .each_insert_opacity
      position absolute
      top 0
      left 0
      display flex
      justify-content center
      align-items center
      width 100%
      height 100%
      background rgba(0, 0, 0, 0.5)

      .each_insert_choice
        width 62px
        height 60px
        border 3px solid #fff
        border-radius 50%
        text-align center
        line-height 60px

        span
          color #fff
          font-size 40px

    img
      display block
      width 100%
      height 100%
      border none
</style>
